import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  faCheck,
  faCircle,
  faEye,
  faEyeSlash,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { STATE_TOKEN, StateModel } from '../../app.states';
import { Select } from '@ngxs/store';

@Component({
  selector: 'ciciam-form-reset-password',
  templateUrl: './form-reset-password.component.html',
})
export class FormResetPasswordComponent implements OnDestroy {
  @Input() websiteName = 'Flowbite';
  @Input() set message(stream: Observable<string | null>) {
    this.subscriptions.add(
      stream.subscribe((x) => this.messageSubject.next(x))
    );
  }

  @Output() credential = new EventEmitter<{
    // account: string;
    // firstName: string;
    // lastName: string;
    password: string;
  }>();
  @Output() register: EventEmitter<any> = new EventEmitter();
  @Output() forgotPassword: EventEmitter<any> = new EventEmitter();

  form = this.fb.nonNullable.group({
    // firstName: ['', Validators.required],
    // lastName: ['', Validators.required],
    password: ['', Validators.required],
    repeatPassword: ['', Validators.required],
  });

  isLoading: boolean = false;

  isPasswordHasLowercase: boolean = false;
  isPasswordHasUppercase: boolean = false;
  isPasswordHasNumber: boolean = false;
  isPasswordLength8: boolean = false;
  isPasswordVisible: boolean = false;
  isRepeatPasswordVisible: boolean = false;

  faCheck = faCheck;
  faTimes = faTimes;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faCircle = faCircle;

  private readonly messageSubject = new BehaviorSubject<string | null>(null);
  public readonly message$ = this.messageSubject.asObservable();

  private readonly subscriptions = new Subscription();

  get formValues() {
    return this.form.getRawValue();
  }

  constructor(private router: Router, private readonly fb: FormBuilder) {
    // const routerState = this.router.getCurrentNavigation()?.extras.state;
    // console.log(`router state: ${JSON.stringify(routerState)}`);
    // if (routerState) {
    //   this.account = routerState['account'];
    // }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onResetPassword() {
    this.messageSubject.next(null);

    this.form.setErrors(null);

    // this.form.controls.firstName.markAllAsTouched();
    // this.form.controls.lastName.markAllAsTouched();

    this.form.controls.password.markAsTouched();
    this.form.controls.repeatPassword.markAsTouched();

    if (
      !(
        this.isPasswordHasLowercase &&
        this.isPasswordHasUppercase &&
        this.isPasswordHasNumber &&
        this.isPasswordLength8
      )
    ) {
      this.form.controls.password.setErrors({
        requirement: 'regerror.password',
      });
    }

    // let formValue = this.form.value;
    let formValue = this.formValues;

    let password = formValue.password;
    let repeatPassword = formValue.repeatPassword;

    // TODO: check password repeat password the same
    if (password !== repeatPassword) {
      // TODO: show error message
      this.form.controls.repeatPassword.setErrors({ match: 'error' });
      return;
    }

    if (!this.form.valid) {
      return;
    }

    this.isLoading = true;
    this.credential.emit({ ...this.formValues });
    // this.credentialForm.reset();
  }

  onRegister($event: any) {
    $event.preventDefault();
    this.register.emit();
  }

  onForgotPassword($event: any) {
    $event.preventDefault();
    this.forgotPassword.emit();
  }

  checkPassword($event: any) {
    let password = this.form.controls.password.value;

    this.isPasswordHasLowercase = /[a-z]/.test(password);
    this.isPasswordHasUppercase = /[A-Z]/.test(password);
    this.isPasswordHasNumber = /[0-9]/.test(password);
    this.isPasswordLength8 = password.length >= 8;
  }

  togglePassword() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleRepeatPassword() {
    this.isRepeatPasswordVisible = !this.isRepeatPasswordVisible;
  }

  onReset() {
    this.isLoading = false;
  }
}
